import { apiClient } from '_app'
import { ApiResponse, NeedsDriversLicensePhotoUploadedDriversLicensePhotoDto, OutboundTripDto, VehicleDto } from 'dtos'
import { NeedsDriversLicensePhotoUploadedDetailsDto } from 'dtos/needsDriversLicensePhotoUploadedDetailsDto'
import { OutboundTripsParameters } from 'parameters'
import { base64ToArrayBuffer, URIQuery } from 'utils'

// # region Needs Drivers License Photo Uploaded
export const getNeedsDriversLicensePhotoUploadedPhotoBase64 = (outboundTripGuid: string, fileName: string) =>
  apiClient
    .get<string>(`/api/outbound-trips/${encodeURIComponent(outboundTripGuid)}/needs-drivers-license-photo-uploaded/${encodeURIComponent(fileName)}`)
    .then(response => response.data)

export const deleteNeedsDriversLicensePhotoUploadedDriversLicensePhoto = (outboundTripGuid: string) =>
  apiClient
    .delete<ApiResponse<NeedsDriversLicensePhotoUploadedDriversLicensePhotoDto>>(
      `/api/outbound-trips/${encodeURIComponent(outboundTripGuid)}/needs-drivers-license-photo-uploaded/drivers-license-photo`
    )
    .then(response => response.data)

export const updateNeedsDriversLicensePhotoUploadedDriversLicensePhotoInformation = (
  outboundTripGuid: string,
  values: NeedsDriversLicensePhotoUploadedDriversLicensePhotoDto
) => {
  const payload = new FormData()

  if (values.driversLicensePhotoFile) {
    payload.append('driversLicensePhotoFile', values.driversLicensePhotoFile)
  }

  return apiClient<ApiResponse<NeedsDriversLicensePhotoUploadedDriversLicensePhotoDto>>({
    data: payload,
    headers: { 'Content-Type': 'multipart/form-data' },
    method: 'put',
    url: `/api/outbound-trips/${encodeURIComponent(outboundTripGuid)}/needs-drivers-license-photo-uploaded/drivers-license-photo`
  }).then(response => response.data)
}

export const getNeedsDriversLicensePhotoUploadedDetails = (outboundTripId: string) =>
  apiClient
    .get<ApiResponse<NeedsDriversLicensePhotoUploadedDetailsDto>>(
      `/api/outbound-trips/${encodeURIComponent(outboundTripId)}/needs-drivers-license-photo-uploaded`
    )
    .then(response => response.data)

export const updateNeedsDriversLicensePhotoUploadedDetails = (outboundTripId: string, values: NeedsDriversLicensePhotoUploadedDetailsDto) =>
  apiClient
    .put<ApiResponse<NeedsDriversLicensePhotoUploadedDetailsDto>>(
      `/api/outbound-trips/${encodeURIComponent(outboundTripId)}/needs-drivers-license-photo-uploaded`,
      values
    )
    .then(response => response.data)

export const getNeedsDriversLicensePhotoUploadedDriversLicensePhotoInformation = (outboundTripGuid: string) =>
  apiClient
    .get<ApiResponse<NeedsDriversLicensePhotoUploadedDriversLicensePhotoDto>>(
      `/api/outbound-trips/${encodeURIComponent(outboundTripGuid)}/needs-drivers-license-photo-uploaded/drivers-license-photo`
    )
    .then(response => response.data)

export const getOutboundTripVehicles = (outboundTripGuid: string, parameters: OutboundTripsParameters) =>
  apiClient
    .get<ApiResponse<VehicleDto[]>>(`/api/outbound-trips/${encodeURIComponent(outboundTripGuid)}/vehicles` + URIQuery({ ...parameters }))
    .then(response => response.data)

export const addVehiclesToOutboundTrip = (outboundTripGuid: string, values: VehicleDto[]) =>
  apiClient.post<ApiResponse<OutboundTripDto>>(`/api/outbound-trips/${encodeURIComponent(outboundTripGuid)}/vehicles`, values).then(response => response.data)

export const removeVehiclesFromOutboundTrip = (outboundTripGuid: string, values: VehicleDto[]) =>
  apiClient
    .delete<ApiResponse<OutboundTripDto>>(`/api/outbound-trips/${encodeURIComponent(outboundTripGuid)}/vehicles`, {
      data: values
    })
    .then(response => response.data)

export const downloadOutboundBillOfLading = (outboundTripGuid: string, fileName: string) => {
  apiClient.get(`/api/outbound-trips/${encodeURIComponent(outboundTripGuid)}/bill-of-lading/${encodeURIComponent(fileName)}`).then(response => {
    const base64Data = response.data
    const buffer = base64ToArrayBuffer(base64Data)

    const extension = fileName.split('.').pop()?.toLowerCase()
    const mimeType = extension === 'png' ? 'image/png' : extension === 'jpg' || extension === 'jpeg' ? 'image/jpeg' : 'application/octet-stream'

    const blob = new Blob([buffer], { type: mimeType })
    const fileUrl = window.URL.createObjectURL(blob)

    window.open(fileUrl, '_blank')

    const a = document.createElement('a')
    a.href = fileUrl
    a.download = fileName
    document.body.appendChild(a)
    a.click()
    document.body.removeChild(a)

    setTimeout(() => URL.revokeObjectURL(fileUrl), 1000)
  })
}
